import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import cta from './../../images/fn-showcase.png'

const useStyles = makeStyles({
	anchorRow: {
		textAlign: 'left',
		display: 'inline-block',
		marginTop: 20
	},
	sectionCta: {
    	backgroundColor: '#442547',
    	backgroundImage: 'linear-gradient(154deg, #023b61 0%,  #4dabb6 100%)',
    	color: '#FFF',
    	padding: 0
	},
	section: {
    	color: '#442547',
    	position: 'relative',
    	width: '100%'
	},
	sectionCtaContent: {
		alignItems: 'center',
    	margin: '0 auto',
    	maxWidth: '80em',
    	position: 'relative',
    	width: '90%',
    	padding: '20px',
    	color:'#fff'
	},
	ctaText: {
    	flex: '1 1 50%',
    	padding: '0 !important'
	},

	ctaHeading: {
	    borderLeft: '0.286em solid #F0C11C',
	    fontSize: '1.625em',
	    lineHeight: '1.2',
	    paddingLeft: '0.75em',
	    fontWeight: '900',
	    textTransform: 'uppercase',
	    marginBottom: '1.5em'
	},
	ctaTextp: {
	    fontSize: '1.325em',
	    lineHeight: '1.3',
        marginBottom: 0,
	    paddingLeft: '1.667em'
	},
	ctaTexta: {
	    backgroundColor: '#FFF',
	    color: '#005382',
	    display: 'inline-block',
	    fontFamily: '"Graphik", monospace',
	    fontWeight: '900',
	    marginLeft: '1.875em',
	    marginTop: '2.25em',
	    padding: '0.875em 1.125em',
	    textDecoration: 'none',
	    textTransform: 'uppercase',
	    "&:hover": {
      		textDecoration: 'none'
    	}
	},
	ctaImage: {
	    flex: '1 0 auto',
	    textAlign: 'center',
	    position: 'relative',
        padding: '0 !important'
	},
	image: {
		maxWidth: '400px'
	}
});

const CTA = () => {
	const classes = useStyles();

	return (
		<Grid container className={classes.anchorRow}>
			<aside className={`${classes.section} ${classes.sectionCta}`}>
			     <Grid container spacing={3} className={classes.sectionCtaContent}>
			         <Grid item xs={12} lg={6} className={classes.ctaText}>
			            <h2 className={classes.ctaHeading}>Need more insights about legislators & other public officials?</h2>
			            <p className={classes.ctaTextp}>FiscalNote's stakeholder management tools help you achieve your goals by combining a vast directory of information on public and private stakeholders, relationship management tools, and AI driven insights.</p>
			            <a className={classes.ctaTexta} target="noopener" href="https://fiscalnote.com/?utm_source=rollcall&utm_medium=member-pages" data-gtm-id="Call to Action Link">Request a Demo</a>
			        </Grid>
			        <Grid item xs={12} lg={6} className={classes.ctaImage}>
			            <img src={cta} className={classes.image} alt="A mobile phone and laptop displaying screenshots from the FiscalNote platform" />
			        </Grid>
			    </Grid>
			</aside>
		</Grid>
	);
}

export default CTA;
